// extracted by mini-css-extract-plugin
module.exports = {"Background":"BuildingInfo__Background__YLCg_","BuildingInfo":"BuildingInfo__BuildingInfo__pI8In"};